export { default as StrategyMapResults } from './StrategyMapResults';
